import { Flex, FormControl, FormLabel, HStack, Spacer } from "@chakra-ui/react"
import { Field } from "formik"
import React from "react"
import styles from "./FormField.module.css"
import ReactQuill from "react-quill"
import "react-quill/dist/quill.snow.css"

const toolbarOptions = [
  //   [{ font: [] }],
  [{ size: ["small", "medium", "large", "huge"] }],
  //   [{ header: "1" }, { header: "2" }, { font: [] }],
  [{ align: [] }],
  ["bold", "italic", "underline"],
  ["blockquote"],
  [{ list: "ordered" }, { list: "bullet" }],
  ["link"],
  [{ color: [] }, { background: [] }], // Add color and background color options
  //   ["image"],
]

export interface FieldType {
  required: boolean
  name: string
  fieldName: string
  filedValue?: string
  disabled?: boolean
  error?: string | undefined
  externalValue?: string
}

const FormEditor: React.FC<FieldType> = (props) => {
  return (
    <>
      <FormControl isRequired={props.required}>
        <Flex width="100%">
          <HStack>
            <FormLabel>{props.name}</FormLabel>
            <Spacer></Spacer>
            <p className={styles.error}>{props.error}</p>
          </HStack>
        </Flex>
        <Field
          name={props.fieldName}
          className={props.error ? styles.errorField : styles.field}
        >
          {/* @ts-ignore */}
          {({ field, meta: { touched }, form }) => {
            // 🔹 NEW: decide what to show in the editor
            const isTouched = form.touched[field.name]
            const displayValue = isTouched
              ? field.value
              : props.externalValue !== undefined
              ? props.externalValue
              : field.value

            return (
              <ReactQuill
                readOnly={!!props.disabled}
                // 🔹 CHANGED: use displayValue instead of props.externalValue || field.value
                value={displayValue || ""}
                // 🔹 CHANGED: correctly update Formik value + mark as touched
                onChange={(content: string) => {
                  if (!form.touched[field.name]) {
                    form.setFieldTouched(field.name, true, false)
                  }
                  form.setFieldValue(field.name, content)
                }}
                modules={{
                  toolbar: toolbarOptions,
                }}
                theme="snow"
              />
            )
          }}
        </Field>
      </FormControl>
    </>
  )
}

export default FormEditor
